import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PlanContext = createContext(null);

export function PlanProvider({ children }) {
  const { user } = useAuth();
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/subscription/access");
      setAccess(data);
    } catch {
      setAccess(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const tier = user?.subscription?.tier;
  const status = user?.subscription?.status;
  useEffect(() => {
    if (user) refresh();
    else setLoading(false);
  }, [user, tier, status, refresh]);

  const hasModule = useCallback((key) => !!access && access.modules.includes(key), [access]);
  const hasFeature = useCallback((key) => !!access && access.features.includes(key), [access]);

  const value = {
    access, loading, refresh, hasModule, hasFeature,
    planId: access?.planId || access?.plan_id,
    limits: access?.limits || {},
    isTeamMember: !!access?.is_team_member,
    teamRole: access?.team_role,
  };
  return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>;
}

export const usePlan = () => useContext(PlanContext) || {
  access: null, loading: true, hasModule: () => true, hasFeature: () => true,
  limits: {}, refresh: () => {}, planId: null, isTeamMember: false, teamRole: null,
};
